import { FloatingIndicator, Tabs } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import styles from './GuidesMainPage.module.scss';

const GuidesMainPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const rootRef = useRef<HTMLDivElement>(null);
  const validTabs = ['instructions', 'checklists'];
  const controlsRefs = useRef<Record<string, HTMLButtonElement | null>>({
    instructions: null,
    checklists: null,
  });
  const { t } = useTranslation();
  const assetId = useCurrentAssetId();

  const getCurrentTab = (pathname: string) => {
    const path = pathname.split('/');
    const foundTab = path.find(segment => validTabs.includes(segment));
    return foundTab ?? 'instructions';
  };

  const [currentTab, setCurrentTab] = useState('');

  useEffect(() => {
    const current = getCurrentTab(location.pathname);
    setCurrentTab(current);
  }, [location.pathname]);

  const handleTabChange = (value: string | null) => {
    if (value && assetId) navigate(`/asset/${assetId}/guides/${value}`);
  };

  return (
    <Tabs value={currentTab} onChange={handleTabChange} className={styles.tabs}>
      <Tabs.List ref={rootRef} className={styles.tabList}>
        <Tabs.Tab ref={node => (controlsRefs.current['instructions'] = node)} value="instructions">
          <div className={styles.tabContent}>
            <span>{t('guides.instructions.title', 'Consignes')}</span>
            <span className={styles.tabSubtitle}>
              {t('guides.instructions.subtitle', "(Modes d'emploi)")}
            </span>
          </div>
        </Tabs.Tab>
        <Tabs.Tab ref={node => (controlsRefs.current['checklists'] = node)} value="checklists">
          <div className={styles.tabContent}>
            <span>{t('guides.checklists.title', 'Checklists')}</span>
            <span className={styles.tabSubtitle}>
              {t('guides.checklists.subtitle', '(À faire)')}
            </span>
          </div>
        </Tabs.Tab>

        <FloatingIndicator
          parent={rootRef.current}
          target={currentTab ? controlsRefs.current[currentTab] : null}
          className={styles.indicator}
        />
      </Tabs.List>

      <Outlet />
    </Tabs>
  );
};

export default GuidesMainPage;
